module.exports = __webpack_public_path__ + "static/media/rotaCoffee2.05f4d1a9.svg";